import { useState } from 'react';
import Axios from 'axios';
import { useNavigate } from 'react-router-dom';
// @mui
import { Stack, IconButton, InputAdornment, TextField, Checkbox, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import Iconify from '../../../components/iconify';

import config from '../../../config.json'
import { API_URL } from '../../../pages/api'




// ----------------------------------------------------------------------

export default function LoginForm() {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);

  const [primeiroLogin, setPrimeiroLogin] = useState(false);

  // const [awake, setAwake] = useState(false);

  const [cfgAll, setCfgAll] = useState();

  const [values, setValues] = useState({
    email: '',
    password: '',
    confirmpassword: ''
  })

  

  const handleClick = () => {
    try {
      Axios.post(`${API_URL}/auth/login`, values)
      .then((res) => {
        localStorage.setItem('userToken', JSON.stringify(res.data.token))
        Axios.get(`${API_URL}/user/${res.data.id}`, { headers: { Authorization: `Bearer ${res.data.token}` } })
        .then(res => {
          // Armazene os dados do usuário no localStorage
          localStorage.setItem('userData', JSON.stringify(res.data.user));
          // localStorage.setItem('userToken', JSON.stringify(res.data.token));
          config.user = res.data.user
          navigate('/modulos', { replace: true });
        })
        .catch(error => {
          window.alert(error.response.data.msg)
        })
      }).catch(error => {
        window.alert(error.response.data.msg)
      })  
    } catch (e){
      window.alert(e)
    } 
  };

  const handleClick2 = () => {
    if(values.password === values.confirmpassword){
      Axios.post(`${API_URL}/auth/primeirologin`, values).then((res) => 
        Axios.get(`${API_URL}/user/${res.data.id}`, { headers: { Authorization: `Bearer ${res.data.token}` } })
        .then(res => {
          config.user = res.data.user
          navigate('/modulos', { replace: true });
        })
        .catch(error => {
          window.alert(error.response.data.msg)
        })
      ).catch(error => {
        console.log(error)
        window.alert(error.response.data.msg)
      })  
    }else{
      window.alert('As senhas precisam serem preenchidas igualmente')
    }
      
};

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });    
  };

  const handleKeyPress = (event) => {
   if(!primeiroLogin){
    if(event.key === 'Enter'){
      handleClick();
    }
   }
   if(primeiroLogin){
    if(event.key === 'Enter'){
      handleClick2();
    }
   }
    
  }

  const handleClickCheck = () => {
    setPrimeiroLogin(!primeiroLogin)
  }

  return (
    <>
      <Stack spacing={3}>
        <TextField name="email" label="Email" onChange={handleChange("email")}/>

        <TextField
          name="password"
          label="Senha"
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
          onChange={handleChange("password")}
          onKeyDown={handleKeyPress}
        />

        {primeiroLogin ? 
          <TextField
          name="confirmpassword"
          label="Confirme a Senha"
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
          onChange={handleChange("confirmpassword")}
          onKeyDown={handleKeyPress}
        />
        : null }
      </Stack>

      <Stack direction="row" alignItems="center" justifyContent="left" sx={{ my: 2 }}>
        <Checkbox name="remember" label="Primeiro Login?" onChange={handleClickCheck}/>
        <Typography variant="subtitle2">
          Primeiro Login?
        </Typography>
          
        
      </Stack>

      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
        {
          !primeiroLogin ?
            <LoadingButton fullWidth size="large" type="submit" variant="contained" onClick={handleClick}>
              Login
            </LoadingButton>
            :
            <LoadingButton fullWidth size="large" type="submit" variant="contained" onClick={handleClick2}>
              Salvar Senha
            </LoadingButton>
        }
        
      </Stack>

      
    </>
  );
}
